import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { BadgeComponent } from '../../../badge/badge.component';
import { MatIcon } from '@angular/material/icon';
import { TabItem, TabMenuStyle } from '../../tab-menu.model';
import { iconDown } from '../../../../svg-icons';
import { IconManager } from '../../../../services/icon-manager.service';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { MatOption } from '@angular/material/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'twc-tab-menu-more-button',
  imports: [
    BadgeComponent,
    MatIcon,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    MatOption,
    NgClass,
  ],
  templateUrl: './tab-menu-more-button.component.html',
  styleUrl: './tab-menu-more-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabMenuMoreButtonComponent {
  private _iconManager = inject(IconManager);

  overflowItems = input.required<TabItem[]>();
  menuStyle = input.required<TabMenuStyle>();

  menuOpened = signal<boolean>(false);

  overflowItemSelected = output<TabItem>();

  constructor() {
    this._iconManager.addIcons([
      {
        name: 'down',
        icon: iconDown,
      },
    ]);
  }

  onOptionClick(item: TabItem) {
    this.overflowItemSelected.emit(item);
    this.menuOpened.set(false);
  }

  protected readonly TabMenuStyle = TabMenuStyle;
}
